<template>
    <div>
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col-12">
                    <grids-crud></grids-crud>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import GridsCrud from './competencies/GridsCrud';

    export default {

        components: {
            GridsCrud
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('common.competency-grids'),
                    },
                ]
            }
        },
    }
</script>
